import { IUserInfo } from "@home-health-notify/domain";
import ListItemText from "@mui/material/ListItemText";
import DisplayAvatarImage from "../../common/DisplayAvatarImage";
import { AddedUserCard, UserAvatar } from "../AddMember.style";
import UserNameWithStatus from "./UserNameWithStatus";

interface IUserCard {
  userInfo: IUserInfo;
  isUserAlreadyInGroup?: boolean;
  hasReferral?: boolean;
  referralMessage?: string;
}

const UserCard = ({
  userInfo,
  isUserAlreadyInGroup,
  hasReferral,
  referralMessage,
}: IUserCard) => {
  return (
    <AddedUserCard>
      <UserAvatar>
        <DisplayAvatarImage src={userInfo.image} alt={userInfo.name} />
      </UserAvatar>
      <ListItemText
        primary={userInfo.title}
        secondary={
          <UserNameWithStatus
            isUserAlreadyInGroup={isUserAlreadyInGroup}
            hasReferral={hasReferral}
            referralMessage={referralMessage}
          />
        }
      />
    </AddedUserCard>
  );
};
export default UserCard;
